import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Alert } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ValidationStepsDisplay = ({ validationResults, title }) => {
  if (!validationResults || validationResults.length === 0) {
    return null;
  }

  return (
    <Card className="mt-3 mb-3">
      <CardBody>
        {title && <h6 className="mb-3">{title}</h6>}
        <div className="validation-steps">
          {validationResults.map((step, index) => {
            const isSuccess = step.value === true;
            const hasFailed = step.value === false;

            return (
              <div
                key={index}
                className={`d-flex align-items-start mb-3 p-3 rounded ${
                  hasFailed ? 'border border-danger bg-light' : 'bg-light'
                }`}
                data-testid={`validation-step-${index}`}
              >
                <div className="mr-3">
                  {isSuccess ? (
                    <span className="fa-stack fa-1x">
                      <FontAwesomeIcon icon="circle" className="branding-green fa-stack-2x" />
                      <FontAwesomeIcon icon="check" className="fa-stack-1x" inverse />
                    </span>
                  ) : (
                    <span className="fa-stack fa-1x">
                      <FontAwesomeIcon icon="circle" className="branding-red fa-stack-2x" />
                      <FontAwesomeIcon icon="times" className="fa-stack-1x" inverse />
                    </span>
                  )}
                </div>
                <div className="flex-grow-1">
                  <div className="d-flex align-items-center mb-1">
                    <strong className="mr-2">Step {index + 1}:</strong>
                    <span>{step.label}</span>
                  </div>
                  {hasFailed && step.errorMessage && (
                    <Alert color="danger" className="mb-0 mt-2 p-2 small">
                      <FontAwesomeIcon icon="exclamation-triangle" className="mr-2" />
                      {step.errorMessage}
                    </Alert>
                  )}
                  {isSuccess && (
                    <div className="text-success small mt-1">
                      <FontAwesomeIcon icon="check-circle" className="mr-1" />
                      Validated successfully
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </CardBody>
    </Card>
  );
};

ValidationStepsDisplay.propTypes = {
  validationResults: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.bool.isRequired,
      errorMessage: PropTypes.string
    })
  ),
  title: PropTypes.string
};

ValidationStepsDisplay.defaultProps = {
  validationResults: [],
  title: 'Validation Results'
};

export default ValidationStepsDisplay;
